import { Typography, LinearProgress, Button, IconButton } from '@material-ui/core';
import '../styles/Globales.scss';
import '../styles/ProductosConfirmacion.scss';
import { observer } from 'mobx-react';

import React, { Component } from 'react';
import appStore from '../stores/AppStore';
import ViewConstants from '../utils/ViewConstants';
import { KeyboardBackspaceOutlined, WarningRounded } from '@material-ui/icons';
import ProductoConfirmarComponent from './utils/ProductoConfirmarComponent';
import ProductoConfirmarCuentaComponent from './utils/ProductoConfirmarCuentaComponent';
import ProductoSinOfertaComponent from './utils/ProductoSinOfertaComponent';

export default observer(
  class ConfirmacionProductosPortarComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        productosPortar: {},
        formularioValido: true,
      };
    }
    onAvanzar = () => {
      let credito = false;
      let tarjeta = false;
      let cuenta = false;
      let linea = false;
      if (this.state.productosPortar.tarjetasSelected) {
        tarjeta = true;
      }
      if (this.state.productosPortar.lineasSelected) {
        linea = true;
      }
      if (this.state.productosPortar.creditosSelected) {
        credito = true;
      }
      if (this.state.productosPortar.cuentas) {
        const cuentasSeleccionadas = this.state.productosPortar.cuentas.filter((item) => {
          return item.selected;
        });
        if (cuentasSeleccionadas && cuentasSeleccionadas.length > 0) {
          cuenta = true;
        }
      }
      appStore.ofertasStore.obtenerOferta(credito, tarjeta, cuenta, linea, this.onOfertaCargada);
    };

    onOfertaCargada = () => {
      appStore.ofertasStore.productosAProtar = this.state.productosPortar;
      appStore.changeNavigation(ViewConstants.ETAPA_OFERTA);
    };

    onVolver = () => {
      appStore.changeNavigation(ViewConstants.ETAPA_LISTADO_SOLICITUDES);
    };

    componentDidMount = () => {
      this.setState({ productosPortar: appStore.ofertasStore.productosAProtar }, this.validarFormulario);
    };

    validarFormulario = () => {
      let result = false;
      if (this.state.productosPortar.tarjetasSelected) {
        result = true;
      }
      if (this.state.productosPortar.lineasSelected) {
        result = true;
      }
      if (this.state.productosPortar.creditosSelected) {
        result = true;
      }
      if (this.state.productosPortar.cuentas) {
        const cuentasSeleccionadas = this.state.productosPortar.cuentas.filter((item) => {
          return item.selected;
        });
        if (cuentasSeleccionadas && cuentasSeleccionadas.length > 0) {
          result = true;
        }
      }
      this.setState({ formularioValido: result });
    };

    renderCreditos = (creditosSelected, creditos) => {
      let result;
      if (creditos && creditos.length > 0) {
        result = <ProductoConfirmarComponent tituloProducto="Créditos" productos={creditos} selected={creditosSelected} switchChange={this.onCreditosSwitchChange} />;
      }
      return result;
    };

    onCreditosSwitchChange = (value) => {
      this.setState(
        (prevState) => ({
          productosPortar: {
            ...(prevState.productosPortar || {}),
            creditosSelected: value, // no muta el objeto previo
          },
        }),
        this.validarFormulario // callback post-actualización (opcional)
      );
    };

    renderTarjetas = (tarjetasSelected, tarjetas) => {
      let result;
      if (tarjetas && tarjetas.length > 0) {
        result = <ProductoConfirmarComponent tituloProducto="Tarjeta de crédito" productos={tarjetas} selected={tarjetasSelected} switchChange={this.onTarjetasSwitchChange} />;
      }
      return result;
    };

    renderLineas = (lineasSelected, lineas) => {
      let result;
      if (lineas && lineas.length > 0) {
        result = <ProductoConfirmarComponent tituloProducto="Línea de crédito" productos={lineas} selected={lineasSelected} switchChange={this.onLineasSwitchChange} />;
      }
      return result;
    };

    renderCuentas = (cuentas) => {
      let result;
      if (cuentas && cuentas.length > 0) {
        result = <ProductoConfirmarCuentaComponent tituloProducto="Cuentas Bancarias" productos={cuentas} switchChange={this.onCuentasSwitchChange} />;
      }
      return result;
    };

    renderProductosSinOferta = (productosSinOfertas) => {
      let result;
      if (productosSinOfertas && productosSinOfertas.length > 0) {
        result = <ProductoSinOfertaComponent tituloProducto="Productos sin Oferta" productos={productosSinOfertas} />;
      }
      return result;
    };

    onCuentasSwitchChange = (value, index) => {
      this.setState(
        (prev) => {
          const cuentas = prev.productosPortar?.cuentas || [];
          const cuentasActualizadas = cuentas.map((cuenta, i) =>
            i === index ? { ...cuenta, selected: value } : cuenta
          );
          return {
            productosPortar: {
              ...(prev.productosPortar || {}),
              cuentas: cuentasActualizadas,
            },
          };
        },
        this.validarFormulario
      );
    };

    onTarjetasSwitchChange = (value) => {
      this.setState(
        (prevState) => ({
          productosPortar: {
            ...prevState.productosPortar,
            tarjetasSelected: value,
          },
        }),
        this.validarFormulario
      );
    };

    onLineasSwitchChange = (value) => {
      this.setState(
        (prevState) => ({
          productosPortar: {
            ...prevState.productosPortar,
            lineasSelected: value,
          },
        }),
        this.validarFormulario
      );
    };

    render() {
      return (
        <div className="contenedorPrincipal">
          <div className="paso">
            <Typography className="tituloBR">
              <IconButton onClick={this.onVolver}>
                <KeyboardBackspaceOutlined />{' '}
              </IconButton>
              Confirmación de productos a portar
            </Typography>
            <LinearProgress variant="determinate" color="secondary" value={4 * (100 / 6)} className="barraProgreso" />
            <Typography className="bajadaTitulo">Confirma los productos que deseas portar.</Typography>
          </div>

          {this.renderCreditos(this.state.productosPortar.creditosSelected, this.state.productosPortar.creditos)}
          {this.renderTarjetas(this.state.productosPortar.tarjetasSelected, this.state.productosPortar.tarjetas)}
          {this.renderLineas(this.state.productosPortar.lineasSelected, this.state.productosPortar.lineas)}
          {this.renderCuentas(this.state.productosPortar.cuentas)}
          {this.renderProductosSinOferta(this.state.productosPortar.productosSinOferta)}

          <div className="mensajeAdvertencia">
            <WarningRounded />
            <Typography className="bajadaTitulo">
              Al seleccionar estos productos, se cerraran en <strong>{appStore.ofertasStore.solicitud.nombreBancoActual}</strong> al término de tu portabilidad
            </Typography>
          </div>
          <div className="botones">
            <Button color="primary" id="btnVerifica" className="btnRipley" onClick={this.onAvanzar} disabled={!this.state.formularioValido}>
              Continuar
            </Button>
          </div>
        </div>
      );
    }
  }
);
